import { InjectionToken } from '@angular/core';
import { SelectOptions } from './shared/components/base-select/base-select.component';

export const CONSUMER_PORTAL_APP_LANG = new InjectionToken<SelectOptions[]>('List of all Available languages');